import { gql } from '@apollo/client';

export const GET_LATEST_DELIVERY_NOTES = gql`
    query GetLatestDeliveryNotes {
        getLatestDeliveryNotes {
            deliveryNoteNumber
            orderTexts
        }
    }
`;
